import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-orange-50 overflow-hidden">
      <div className="container mx-auto px-4 py-12 md:py-20">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="order-2 md:order-1 space-y-6">
            <div className="bg-orange-500 text-white px-4 py-2 rounded-lg inline-block font-bold text-sm mb-2 animate-pulse break-words">
              🔥 TECNICO DISPONIBILE ORA
            </div>
            
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight break-words">
              <span className="text-orange-600">Arriviamo entro 60 minuti</span>
              <span className="block mt-2">a Roma</span>
            </h2>
            
            <div className="bg-blue-700 text-white p-4 rounded-lg shadow-lg break-words">
              <p className="text-xl sm:text-2xl md:text-3xl font-bold mb-2">
                ⚡ Intervento Immediato H24
              </p>
              <p className="text-base sm:text-lg break-words">
                Idraulico • Elettricista • Caldaie • Climatizzatori
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-xl border-2 border-orange-500">
              <p className="text-lg sm:text-xl font-bold text-gray-900 mb-3 break-words">
                💰 Prezzi Chiari da Subito
              </p>
              <div className="grid grid-cols-2 gap-3 text-sm sm:text-base text-gray-700">
                <div>✅ Chiamata gratuita</div>
                <div>✅ Preventivo immediato</div>
                <div>✅ Da 60€</div>
                <div>✅ Paghi a lavoro fatto</div>
              </div>
            </div>
            
            <div className="flex flex-col gap-4 pt-4 w-full max-w-full">
              <a
                href="https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20intervento%20a%20Roma.%20Potete%20intervenire%20oggi?"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-orange-500 hover:bg-orange-600 text-white text-lg sm:text-xl md:text-2xl px-6 sm:px-8 md:px-12 py-6 sm:py-7 md:py-8 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 font-bold animate-pulse flex items-center justify-center gap-2 sm:gap-3 w-full max-w-full break-words"
              >
                <MessageCircle className="h-6 w-6 sm:h-7 sm:w-7 md:h-8 md:w-8 flex-shrink-0" />
                <span className="break-words">💬 SCRIVI SU WHATSAPP ORA</span>
              </a>
              
              <a
                href={`tel:${contactInfo.phone}`}
                className="bg-blue-700 hover:bg-blue-800 text-white text-base sm:text-lg md:text-xl px-6 sm:px-8 md:px-10 py-5 sm:py-6 md:py-7 rounded-lg shadow-xl transition-all duration-300 hover:scale-105 font-bold flex items-center justify-center gap-2 sm:gap-3 w-full max-w-full break-words"
              >
                <Phone className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7 flex-shrink-0" />
                <span className="break-words">📞 CHIAMA: 328 768 6356</span>
              </a>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg border-2 border-green-500">
              <p className="text-gray-900 font-bold text-center text-base sm:text-lg break-words">
                ✅ Operativi H24, 7 giorni su 7 • Anche Festivi
              </p>
            </div>
          </div>
          
          <div className="order-1 md:order-2">
            <img
              src="/hero-image-sos-casa-roma.png"
              alt="Tecnico SOS Casa Roma al lavoro - Pronto intervento idraulico, caldaie ed elettricista a Roma H24"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover max-w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
